export default [
    {
        // 仓库发货规则
        path: "rules/warehouseDeliver",
        name: 'warehouseDeliver',
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/index.vue"),
    },
    {
        // 仓库发货规则添加、查看、编辑
        path: 'rules/warehouseDeliver/update/:type/:level',
        name: 'warehouseDeliverUpdate',
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/update.vue"),
    },
    {
        // 人工审核规则
        path: "rules/audit",
        name: 'auditRules',
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/audit/index"),
    },
    {
        // 仓库发货规则添加、查看、编辑
        path: 'rules/audit/update/:type/:level',
        name: 'auditRulesUpdate',
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/update.vue"),
    },
    {
        // 订单发货规则
        path: "rules/order/list",
        name: "orderRules",
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/order/index"),
    },
    {
        // 订单发货规则添加查看编辑
        path: "rules/order/update/:type",
        name: "orderRulesUpdate",
        component: () => import(/* webpackChunkName: "rules" */ "@/views/rules/order/update.vue"),
    }
]